module.exports = __webpack_public_path__ + "img/hagerup_Folkekjaer_og_kontroversiell1.32bee6e6.jpg";